var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body"},[_c('MovieItemFeed',{attrs:{"listType":_vm.listType}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }